import { FC } from 'react'
import reactStringReplace from 'react-string-replace'

import * as SC from '../styles'
import { routes } from 'commons/constants/routes'
import { Accordion, Icon, IconName, Link, Panel, PanelFace, TextBadge } from 'ui/components'
import { ChangesTable } from 'ui/temp/Changes'

import { RelationshipChangesProps } from './RelationshipChangesProps'

export const RelationshipChanges: FC<RelationshipChangesProps> = (props) => {
  const {
    data: {
      showRelationshipChanges: { showChanges, title, id }
    },
    showAll
  } = props

  return (
    <Panel
      title="Relationship"
      titleTagAs="h3"
      face={PanelFace.SMALL_PRIMARY}
      isArrowButton
      rounded
      shadowed
      expanded={showAll}
    >
      {showChanges && (
        <Accordion
          title="Updated"
          expanded={showAll}
          actions={<TextBadge color="default">{showChanges.length} changes</TextBadge>}
          bottomPadding="small"
        >
          <SC.AccordionTitle>
            <Icon name={IconName.EXCLAMATION_ORANGE} />
            <span>
              {reactStringReplace(title, /%#(.*)#%/g, (match, i) => (
                <Link key={i} to={routes.bank.relationships.details} params={{ id: id.toString() }}>
                  {match}
                </Link>
              ))}
            </span>
          </SC.AccordionTitle>
          <ChangesTable changes={showChanges} dataQa="relationship" />
        </Accordion>
      )}
    </Panel>
  )
}
